angular.module('cvsApp').service('trackPackageService',['networkService', 'xdrService', 'trackPackageModel', 'configManager', function (NS, XS, TAPM, CM) {
   	
	function trackPackageService (){	
		this.trackPackage = function(req, callBackSuccess){
			//get url 
			var url = CM.getGuestUrl('TRACK_PACKAGE');
			var request = {url:url,
							header:{"Content-Type":"application/xml"},
							data:getRequestBody(req),
							onSuccess:callBackSuccess
						};
			cvsUtility.commonServiceCode(url,"retrieveTrackingDetails",TAPM,request,callBackSuccess,NS);
							
		};
		
		var getRequestBody = function(req){
				var timeStamp=cvsUtility.getTimeStamp();					
				var requestJson = {request:{
								apiKey:cvsUtility.queryMap.apikey,
								carrierName:req.carrierName,
								trackingNumber:req.trackingNumber,
								timestamp:timeStamp
							}};
				
				return cvsUtility.JSONToXml(requestJson);

			};			
	}
	
	return new trackPackageService();	
}]);
